/**
 * Junoa Network — 中心化品牌配置（白标补丁层）
 *
 * 所有用户可见的品牌字符串、域名、社交链接、法律主体集中在此。
 * 替换上游 Akash 硬编码时，一律改为从这里 import 引用，
 * 这样未来同步上游 main 只需 merge 引用，不会因字符串内容产生冲突。
 *
 * 导入示例：import { SITE_CONFIG } from "@src/config/site.config";
 */

export const SITE_CONFIG = {
  // —— 品牌 ——
  brandName: "Junoa Network",
  brandShortName: "Junoa",
  productName: "Junoa Network Console",

  // —— 域名 ——
  // net.junoa.ai 作为主控台 canonical 域；其余服务暂挂在 junoa.ai 顶级域子域下。
  // 若你的子域规划不同（例如都挂在 net.junoa.ai 下），改本块即可，全站跟随。
  domain: "https://net.junoa.ai",
  domains: {
    console: "https://net.junoa.ai",
    stats: "https://status.net.junoa.ai",
    api: "https://api.net.junoa.ai",
    proxy: "https://proxy.net.junoa.ai",
    proxyWs: "wss://proxy.net.junoa.ai",
    docs: "https://docs.net.junoa.ai",
    marketing: "https://junoa.ai"
  },

  // —— SEO / 社交卡 ——
  description: "Junoa Network Console — deploy and manage containerized workloads on a decentralized cloud, all in one place.",
  ogImage: "/junoa-console.png", // 1200×630，Phase 2 生成后放入 public/
  twitterHandle: "@junoa", // 占位，待你提供真实 handle

  // —— 社交 / 外链（占位，待你提供后填；空串会在组件侧隐藏对应入口）——
  social: {
    twitter: "",
    discord: "",
    youtube: "",
    github: "", // 私有 GitLab；外链建议指向 docs 或留空
    docs: "https://docs.net.junoa.ai"
  },

  // —— 法律主体 ——
  legal: {
    companyName: "UECONNECT PTE. LTD.",
    supportEmail: "support@joypow.net",
    address: "" // 待补：注册地址（隐私/条款/邮件用）
  },

  // —— 品牌色（DESIGN.md，主题方案 A 的权威 hex 参考；
  //     CSS 变量真正落地在 packages/ui/styles/global.css，Phase 2 据此派生）——
  brandColors: {
    primary: "#cc785c",
    primaryActive: "#a9583e",
    accent: "#e8a55a",
    logoInk: "#141413", // 浅背景的标志色
    logoOnDark: "#faf9f5" // 深背景的标志色
  }
} as const;

export type SiteConfig = typeof SITE_CONFIG;
